export interface PayphoneLocation {
	id?: string
	location: {
		address: string
		geometry: {
			lat: number
			lng: number
		}
		name: string
	}
	name: string
	phone_numbers: string[]
	pickup_instructions: string
}

export const emptyPayphoneLocation = (defaultLat = 0, defaultLng = 0): PayphoneLocation => ({
	location: {
		address: '',
		geometry: {
			lat: defaultLat,
			lng: defaultLng,
		},
		name: '',
	},
	name: '',
	phone_numbers: [''],
	pickup_instructions: '',
})
